module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Luk","flags":["TRACK"],"track":"Close"}}